"use client";

// مرز code-split سمت client: dynamic() فقط داخل کامپوننت client چانک جدا می‌سازد
// (از Server Component همه‌ی کد client صفحه‌ها در یک چانک مشترک می‌آمد).
import dynamic from "next/dynamic";

// بدون loading fallback تا DOM دوبار ساخته نشود؛ SSR مثل قبل انجام می‌شود.
export default dynamic(() => import("./_component"));
